import { RouterProvider } from 'react-router';

import {
  VModalProvider,
  VThemeProvider,
  VToastProvider,
  VUEX_THEME,
} from '@/package';

import { ErrorBoundary, ErrorFallback } from './component';
import router from './router';
import appWorker from './worker';

await appWorker.request('idb', 'getStoreNameList');

const App = () => {
  return (
    <ErrorBoundary
      fallbackRender={({ error, info, resetErrorBoundary }) => (
        <ErrorFallback
          code={500}
          info={info}
          error={error}
          onRefresh={resetErrorBoundary}
        />
      )}
    >
      <VThemeProvider theme={VUEX_THEME}>
        <VModalProvider>
          <VToastProvider>
            <RouterProvider router={router} />
          </VToastProvider>
        </VModalProvider>
      </VThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
